<template>
    <v-dialog persistent :max-width="Modal.Confirmacao.larguraMaxima" v-model="deveMostrarModalHomologacao">
        <v-card :max-width="Modal.Confirmacao.larguraMaxima" :min-width="Modal.Confirmacao.larguraMinima">
            <v-card-title primary-title class="primary modal-title">
                <span class="">Adjudicar/Homologar</span>
                <v-spacer></v-spacer>
                <v-icon color="white" @click.stop="$emit('cancelar')">close</v-icon>
            </v-card-title>
            <v-card-text class="my-0">
                <p class="primary--text text--darken-1 primary lighten-5 font-weight-bold pa-2 d-inline-flex align-start rounded"
                   style="align-items: center; width: 100%;">
                    <v-icon color="primary" flat>info</v-icon>
                    <span>Exibindo apenas itens/lotes aguardando homologação.</span>
                </p>
            </v-card-text>
            <v-card-text class="py-0 mb-3" style="overflow-y: auto; max-height: 500px">
                <p class="grey--text text--darken-3">Selecione os itens/lotes para adjudicar/homologar:</p>
                <v-layout row wrap>
                    <v-flex xs12 d-flex single-line style="height: 40px;">
                        <v-checkbox label="Todos"
                                    color="primary"
                                    :input-value="itensSelecionados.length > 0"
                                    :indeterminate="itensSelecionados.length > 0"
                                    @change="marcarDesmarcarTodos"></v-checkbox>
                    </v-flex>

                    <v-flex xs12 sm4 d-flex v-for="item in resultados" :key="item.id" style="height: 40px;">
                        <v-checkbox :key="item.id" :label="item.descricao"
                                    v-model="itensSelecionados"
                                    return-object
                                    :value="item"
                                    color="primary"/>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-card-actions class="px-3 py-2">
                <v-btn flat outline color="botao-cancelar-color" @click.stop="itensSelecionados = []; $emit('cancelar')">Voltar</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" depressed @click.stop="$emit('confirmar', [...itensSelecionados]);">Salvar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import {Modal} from '@/core/constants'

export default {
    name: 'ModalHomologarAdjudicarItemLote',
    props: {
        resultados: {
            type: Array,
            default: () => []
        },
        deveMostrarModalHomologacao: {
            type: Boolean,
            default: false
        },
    },
    data: () => ({
        itensSelecionados: [],
        Modal
    }),
    methods: {
        marcarDesmarcarTodos() {
            if (this.itensSelecionados.length) this.itensSelecionados = []
            else this.itensSelecionados = this.resultados.slice()
        },
    },
    watch: {
        deveMostrarModalHomologacao(novoValor) {
            if (novoValor === true) this.itensSelecionados = []
        },
    },
}
</script>

<style scoped lang="stylus">

</style>